import React from "react";
import "../../styles/styles.css";

const MientrasSelecciona2 = () => {
  return (
    <div className="loader2">
      <div className="beerWrapper2">
        <div className="beerMug2">
          <div className="beerLiquid2"></div>
          <div className="beerFoam2"></div>
        </div>
        <div className="mugHandle2"></div>
      </div>
    </div>
  );
};

export default MientrasSelecciona2;
